const MAP = {
  paid: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border-emerald-500/40",
  partial: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border-amber-500/40",
  unpaid: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border-red-500/40",
};
const LABEL = { paid: "Paid", partial: "Partially Paid", unpaid: "Unpaid" };

export const PayStatusBadge = ({ status, className = "" }) => {
  const s = MAP[status] ? status : "unpaid";
  return (
    <span className={`inline-block px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide border ${MAP[s]} ${className}`} data-testid={`pay-status-${s}`}>
      {LABEL[s]}
    </span>
  );
};
